export const MODAL_MODES = {
  ADD_EXISTING: 'add_existing',
  ADD_NEW: 'add_new',
  EDIT_EXISTING: 'edit_existing',
}
